import React from 'react';

type IProps = {
    value?: string;
    onChange?: (value: string) => void;
    name?: string;
    field: any;
    defaultColor?: string;
};

const ColorPicker: React.FC<IProps> = ({ value, onChange, name, field, defaultColor = '#ffffff', ...rest }) => {
    return (
        <div className="color-wrapper">
            <input
                type="color"
                {...rest}
                name={name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    onChange?.(e.target.value);
                }}
                {...field}
                value={value || field?.value || defaultColor}
            />
        </div>
    );
};

export default React.memo(ColorPicker);
